import {
  BasisStreckenState,
  GlobalAction,
  GlobalActions,
  Zaehlstueck,
  ZaehlstueckeReceived,
} from '@ps20-frontend/shop-integration-redux';

export function rabattstufeReducer(
  sectionState: number = null,
  action: GlobalAction<ZaehlstueckeReceived>,
  appState: BasisStreckenState,
): number {
  if (action.type === GlobalActions.ZAEHLSTUECKE_RECEIVED) {
    const actionPayload: ZaehlstueckeReceived = action.payload;
    if (appState.produkt?.produktlinien) {
      const kurztexte = new Set<string>(
        appState.produkt.produktlinien.map(value => value.kurztext),
      );
      const zaehlstueck: Zaehlstueck = actionPayload.zaehlstuecke.find(
        value => kurztexte.has(value.kurztext) && appState.angebotsId === value.angebotsId,
      );
      return zaehlstueck ? Math.min(zaehlstueck.rabattstufe, 5) : sectionState;
    }
    return sectionState;
  }
  return sectionState;
}
